'use strict';

import Component from 'generic.basecomponent';
import $ from "jquery";
import tippy from "tippy.js"



export default class Tooltip extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {

        this.tooltip = tippy(this.container, {
            delay: 100,
            arrow: true,
            arrowType: 'sharp',
            size: 'small',
            duration: 250,
            animation: 'scale',
            maxWidth: '300px',
            placement: 'top',
            interactive: 'false',
            html: this.container.querySelector('.js-tooltip-content')
        });

    }




}



// WEBPACK FOOTER //
// ./app/components/tooltip/js/generic.tooltip.js